export const buttonStyles = {
  chartRadio: {
    ml: '12px',

    '& .MuiFormControlLabel-root': {
      color: '#FF9900 !important',
    },

    '& .MuiButtonBase-root': {
      p: '2px',
    },
    '& .MuiFormControlLabel-label': {
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '18px',
      color: '#464255',
    },
  },
};
